// Tools public
//
// Functions, utilities, and constants used in the project.
const CLASS_NAME_SHOW$1 = 'show'
const CLASS_NAME_SHOW$2 = 'active'
const CLASS_NAME_SHOW$3 = 'hidden'

// * getSelector
const getSelector = (element, attribute) => {
	let selector = element.getAttribute(attribute)

	if (!selector || selector === '#') {
		let hrefAttr = element.getAttribute('href')

		if (!hrefAttr || (!hrefAttr.includes('#') && !hrefAttr.startsWith('.'))) {
			return null
		}

		if (hrefAttr.includes('#') && !hrefAttr.startsWith('#')) {
			hrefAttr = `#${hrefAttr.split('#')[1]}`
		}

		selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : null
	}

	return selector
}

// * getSelectorFromElement
const getSelectorFromElement = (element, attribute) => {
	const selector = getSelector(element, attribute)

	if (selector) {
		return document.querySelector(selector) ? selector : null
	}

	return null
}

// * onToggle
// *
// * function toggle class of element
const onToggle = (element, nameClass = CLASS_NAME_SHOW$1) => {
	if (element === null) return null

	element.classList.toggle(`${nameClass}`)
}

// * onShow
// *
// * function for add class to element
const onShow = (element, nameClass = CLASS_NAME_SHOW$1) => {
	if (element === null) return null

	if (element.classList.contains(nameClass)) {
		return null
	}

	element.classList.add(`${nameClass}`)
}

// * onHide
// *
// * function for remove class to element
const onHide = (element, nameClass = CLASS_NAME_SHOW$1) => {
	if (element === null) return null

	if (!element.classList.contains(nameClass)) {
		return null
	}

	element.classList.remove(`${nameClass}`)
}

// * onUpdateAttribute
// *
// * function for updated attibute of element
const onUpdateAttribute = (element, attribute, value) => {
	if (element === null) return null

	if (!element.hasAttribute(attribute)) return null

	element.setAttribute(attribute, value)
}

const onStylesELement = (element, styles = '') => {
	if (element === null) return null

	element.setAttribute('style', styles)
}

// * onGetStorage
// *
// * function for get item in sessionStorage or localStorage
const onGetStorage = (session = true, searchItem) => {
	if (session) {
		// sessionStorage
		if (sessionStorage.getItem(searchItem) === null)
			return console.warn('No exist element in sessionStorage')

		return sessionStorage.getItem(searchItem)
	} else {
		// localStorage
		if (localStorage.getItem(searchItem) === null)
			return console.warn('No exist element in localStorage')

		return localStorage.getItem(searchItem)
	}
}

// * onSetStorage
// *
// * function for created item in sessionStorage or localStorage
const onSetStorage = (session = true, searchItem, contentItem) => {
	if (session) {
		// sessionStorage
		if (sessionStorage.getItem(searchItem) === null)
			return console.warn(
				'No exist element in sessionStorage, it is not possible updated element'
			)

		return sessionStorage.setItem(searchItem, contentItem)
	} else {
		// localStorage
		if (localStorage.getItem(searchItem) === null)
			return console.warn(
				'No exist element in localStorage, it is not possible updated element'
			)

		return localStorage.setItem(searchItem, contentItem)
	}
}
